module.exports = __webpack_public_path__ + "static/media/starter-cerdits.21433e6d.png";